export default __webpack_public_path__ + "static/media/buttonAHover.eafa8e3f.png";